<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-container grid-list-lg>
      <v-row class="pb-3 mb-3" style="border-bottom: 1px solid #ededed">
        <v-col class="col-12">
          <h2
            class="mx-2 text-xs-center text-md-left font-weight-regular"
            style="color: var(--v-primary-base)"
          >
            <v-icon size="32" color="primary">date_range</v-icon>Agenda
          </h2>
        </v-col>
      </v-row>
      <v-row class="justify-space-between">
        <v-col class="col-12 col-md-5 col-lg-6 text-center">
          <div class="pa-3 mb-3 subheading" style="background: #02a554; color: #ffffff">
            Escolhe o dia com horários de disponibilidade.
          </div>
          <v-date-picker
            v-model="date"
            full-width
            locale="pt-br"
            color="primary"
            :min="minDate"
          ></v-date-picker>
        </v-col>
        <v-col class="col-12 col-md-6 align-center">
          <div class="pa-3 mb-3 subheading text-center" style="background: #02a554; color: #ffffff">
            Escolha os horários disponíveis para o dia selecionado.
          </div>
          <div>
            <v-row class="px-3 justify-center">
              <v-col class="shrink pa-1 col-auto" v-for="(hour, index) in hours" :key="index">
                <v-checkbox
                  class="list__hours"
                  v-model="selected"
                  :value="hour.value"
                  :label="hour.description"
                ></v-checkbox>
              </v-col>
              <v-col class="col-12 text-center text-sm-right">
                <v-btn class="mr-4" large text @click="$router.go(-1)">CANCELAR</v-btn>
                <v-btn
                  color="secondary"
                  large
                  @click="editSchedele"
                  :disabled="isDisabled"
                  :loading="loader"
                  >{{ $t('pageCreateAgenda.btnSalvar') }}</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Axios from 'axios';
import moment from 'moment-timezone';
import {
  getSchedule,
  deleteSchedule,
  createSchedule,
  getProfile,
} from '../../services/psychologists';

export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      hours: [
        {
          value: '00:00:00',
          description: '00h-01h',
        },
        {
          value: '01:00:00',
          description: '01h-02h',
        },
        {
          value: '02:00:00',
          description: '02h-03h',
        },
        {
          value: '03:00:00',
          description: '03h-04h',
        },
        {
          value: '04:00:00',
          description: '04h-05h',
        },
        {
          value: '05:00:00',
          description: '05h-06h',
        },
        {
          value: '06:00:00',
          description: '06h-07h',
        },
        {
          value: '07:00:00',
          description: '07h-08h',
        },
        {
          value: '08:00:00',
          description: '08h-09h',
        },
        {
          value: '09:00:00',
          description: '09h-10h',
        },
        {
          value: '10:00:00',
          description: '10h-11h',
        },
        {
          value: '11:00:00',
          description: '11h-12h',
        },
        {
          value: '12:00:00',
          description: '12h-13h',
        },
        {
          value: '13:00:00',
          description: '13h-14h',
        },
        {
          value: '14:00:00',
          description: '14h-15h',
        },
        {
          value: '15:00:00',
          description: '15h-16h',
        },
        {
          value: '16:00:00',
          description: '16h-17h',
        },
        {
          value: '17:00:00',
          description: '17h-18h',
        },
        {
          value: '18:00:00',
          description: '18h-19h',
        },
        {
          value: '19:00:00',
          description: '19h-20h',
        },
        {
          value: '20:00:00',
          description: '20h-21h',
        },
        {
          value: '21:00:00',
          description: '21h-22h',
        },
        {
          value: '22:00:00',
          description: '22h-23h',
        },
        {
          value: '23:00:00',
          description: '23h-24h',
        },
      ],
      selected: [],
      cod: '',
      loader: false,
      snackbar: false,
      msg: '',
      time_zone_name: '',
      isDisabled: false,
    };
  },
  async created() {
    this.getCod();
    this.getSchedele();
  },
  computed: {
    /**
     * Informa para o datepicker a data minima para ser escolhida.
     */
    minDate() {
      const today = new Date();
      return this.formatDate(today);
    },
  },
  watch: {
    date(val) {
      this.getSchedele();
    },
  },
  methods: {
    async getSchedele() {
      try {
        this.selected = [];
        const data_user = JSON.parse(localStorage.getItem('user-data'));
        this.time_zone_name = data_user.time_zone_name;
        const { data, status } = await getSchedule(this.cod, this.date);

        if (status == 200) {
          console.log(data);
          for (const item of data) {
            const auxTime = moment
              .utc(`${item.date} ${item.time}`)
              .tz(`${this.time_zone_name}`)
              .format('HH:mm:ss');
            this.selected.push(auxTime);
          }
          console.log(this.selected);
        }
        // console.log(this.selected);
      } catch (error) {
        console.log(error);
      }
    },
    async editSchedele() {
      this.loader = true;
      try {
        const { data, status } = await deleteSchedule(this.cod, this.date);
        console.log(data);
        console.log(status);

        if (status == 200) {
          this.postSchedele();
        }
        // if(response.data.error){
        //   console.log(response.data.error);
        //   return response.data.error
        // }else{
        //   this.postSchedele();
        // }
      } catch (error) {
        console.log(error);
      }
    },
    async postSchedele() {
      try {
        const list = await this.creatListData();
        const { data, status } = await createSchedule(this.cod, list);

        if (status === 201) {
          console.log(data);
          this.msg = 'Cadastro realizado com sucesso!';
          this.snackbar = true;
          setTimeout(() => {
            this.$router.replace('/psicologo/schedule');
          }, 3000);
        }
      } catch (error) {
        console.log(error);
        this.msg = 'Ocorreu um erro ao cadastrar a agenda!';
        this.snackbar = true;
      } finally {
        this.loader = false;
      }
    },

    async getCod() {
      this.cod = localStorage.getItem('user-id');
      const user = await getProfile(this.cod);
      if (!user.digital_account) {
        this.isDisabled = true;
        const res = await this.$showDialog({
          title: 'Você ainda não possui uma forma de pagamento.',
          message:
            'Deseja criá-la agora? É necessário ter uma forma de pagamento para disponibilizar horários em sua agenda.',
          labelButton: 'Criar Conta bancária',
          options: {
            color: 'success',
            width: '500',
            singleButton: true, // Opcional: Retira o botão CANCELAR e deixa apenas o botão do labelButton.
            titleColor: 'primary--text', // Opcional: Modifica a cor do título do modal
          },
        });
        if (res) {
          this.$router.replace('/psicologo/cadastro-bancario/');
        }
      }

      if (!user.is_active) {
        this.$router.replace('/psicologo/');
        this.$showSnackbar('Você está inativo e não pode entrar nesta tela.');
      }
    },

    creatListData() {
      const listDate = this.date.split(', ');
      const data = [];
      for (const date of listDate) {
        for (const time of this.selected) {
          const item = {
            date,
            time: moment.tz(`${date} ${time}`, `${this.time_zone_name}`).utc().format('HH:mm'),
          };
          data.push(item);
        }
      }
      console.log(data);
      return data;
    },
    /**
     * formata data e retorna para a função que vai informa ao datepicker
     * apartir de que data inicia.
     * params: $date
     */
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
  },
};
</script>

<style scoped>
.flatpickr-input {
  display: none;
}
* >>> .list__hours {
  margin-top: 0px;
}

* >>> .list__hours .v-input--selection-controls__input {
  display: none;
}

* >>> .list__hours.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0;
  background: #cbcbcb;
  /* border: 2px solid #02a554; */
  padding: 8px 16px;
  border-radius: 23px;
}
* >>> .list__hours.v-input--selection-controls.v-input .v-label {
  color: #000000;
}
* >>> .list__hours.v-input--is-label-active .v-input__control .v-input__slot {
  background: #02a554;
}
* >>> .flatpickr-calendar,
* >>> .flatpickr-rContainer,
* >>> .flatpickr-days {
  width: 450px;
}
* >>> .flatpickr-day {
  max-width: 57px;
  height: 57px;
  line-height: 57px;
}
* >>> .dayContainer {
  width: 450px;
  max-width: 450px;
}
</style>
